import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { ReduxStore } from '../types/redux/state';
import { authStore } from './auth-store';
import { logout } from './authentication-slice';
import ConfigureStore from './configureStore';

const store = ConfigureStore();

authStore.setLogoutDispatch(() => store.dispatch(logout()));

type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ReduxStore> = useSelector;

export { store };

// Expose redux store for Cypress:
// @ts-expect-error -- Cypress global
if (window.Cypress) {
  // @ts-expect-error -- only used in cypress
  window.store = store;
}
